import {AfterViewInit, Directive, ElementRef, input} from '@angular/core';
import {InputBooleanTransform} from '@utils';

@Directive({
	selector: '[dcAutoFocus]',
})
export class AutoFocusDirective implements AfterViewInit {
	readonly dcAutoFocus = input(true, {transform: InputBooleanTransform});

	constructor(private elementRef: ElementRef) {}

	ngAfterViewInit(): void {
		if (this.dcAutoFocus()) this.elementRef.nativeElement.focus();
	}
}
